import clsx from 'clsx'
import CommentList, { type CommentListProps } from '../Comment/CommentList'
import CommentListOrderSelect from '../Comment/CommentListOrderSelect'
import styles from './CommentListSection.module.css'

export type CommentListSectionProps = CommentListProps

export default function CommentListSection({
	data = [],
	isLoading = false,
	className,
	...props
}: CommentListSectionProps) {
	return (
		<section className={clsx(styles.section, className)} {...props}>
			<header className={styles.header}>
				<span>全部评论</span>
				<CommentListOrderSelect />
			</header>

			<CommentList isLoading={isLoading} data={data} />
		</section>
	)
}
